
import { openFinanceApi } from './integrations'

// transaction_type: "C" = receita | "D" = despesa
// status: "pending" | "paid" | "overdue" | "canceled" | "todos"

export const listTransactions = (params = {}) =>
  openFinanceApi.get('/transactions/', { params }).then(r => r.data)

export const getTotals = (params = {}) =>
  openFinanceApi.get('/transactions/totals', { params }).then(r => r.data)

export const getTransaction = (id) =>
  openFinanceApi.get(`/transactions/${id}`).then(r => r.data)

export const createTransaction = (data) =>
  openFinanceApi.post('/transactions/', data).then(r => r.data)

export const updateTransaction = (id, data) =>
  openFinanceApi.put(`/transactions/${id}`, data).then(r => r.data)

export const darBaixa = (id, data) =>
  openFinanceApi.post(`/transactions/${id}/baixa`, data).then(r => r.data)

export const estornarBaixa = (id, data) =>
  openFinanceApi.post(`/transactions/${id}/estorno`, data).then(r => r.data)

export const cancelarTransaction = (id, data) =>
  openFinanceApi.post(`/transactions/${id}/cancelar`, data).then(r => r.data)

export const deleteTransaction = (id) =>
  openFinanceApi.delete(`/transactions/${id}`)

export const listPersons = (params = {}) =>
  openFinanceApi.get('/financial-persons/', { params }).then(r => r.data)

export const createPerson = (data) =>
  openFinanceApi.post('/financial-persons/', data).then(r => r.data)


export const listAccounts = (params = {}) =>
  openFinanceApi.get('/chart-of-accounts/', { params }).then(r => r.data)

export const createAccount = (data) =>
  openFinanceApi.post('/chart-of-accounts/', data).then(r => r.data)

export const updateAccount = (id, data) =>
  openFinanceApi.put(`/chart-of-accounts/${id}`, data).then(r => r.data)

export const deleteAccount = (id) =>
  openFinanceApi.delete(`/chart-of-accounts/${id}`)


export const listCostCenters = () =>
  openFinanceApi.get('/cost-centers/').then(r => r.data)

export const createCostCenter = (data) =>
  openFinanceApi.post('/cost-centers/', data).then(r => r.data)

export const updateCostCenter = (id, data) =>
  openFinanceApi.put(`/cost-centers/${id}`, data).then(r => r.data)

export const deleteCostCenter = (id) =>
  openFinanceApi.delete(`/cost-centers/${id}`)


export const listBankAccounts = () =>
  openFinanceApi.get('/bank-accounts/').then(r => r.data)

export const createBankAccount = (data) =>
  openFinanceApi.post('/bank-accounts/', data).then(r => r.data)

export const updateBankAccount = (id, data) =>
  openFinanceApi.put(`/bank-accounts/${id}`, data).then(r => r.data)

export const deleteBankAccount = (id) =>
  openFinanceApi.delete(`/bank-accounts/${id}`)



// WEBPACK FOOTER //
// ./src/api/openFinanceTransactions.js